import { useConfig } from '../../../_components/config';

import { devData } from './dev';
import { qaData } from './qa';
import { stageData } from './stage';

export const useMocks = () => {
  const { env } = useConfig();
  return (
    { dev: devData, qa: qaData, stage: stageData }[env as string] ?? devData
  );
};
